import { useMemo } from "react";
import { useSelector } from "@/core/redux/store";
import useUserTokenBalanceSubscription from "./useUserTokenBalanceSubscription";
import { useTranslation } from "react-i18next";

export default function useCurrentTokenBalance() {
  const me = useSelector((state) => state.user.me);
  const { i18n } = useTranslation();

  const currentTokenBalance = useSelector(
    (state) => state.user.currentTokenBalance
  );
  const userId = me?.id;

  useUserTokenBalanceSubscription(userId);

  const currentTokenBalanceFormatted = useMemo(
    () => Math.trunc(currentTokenBalance || 0).toLocaleString(i18n.language),
    [currentTokenBalance, i18n.language]
  );
  return {
    currentTokenBalance,
    currentTokenBalanceFormatted,
  };
}
